import React from 'react'
import { PageFooter, Animation, Flex, Button } from 'styling/GlobalStyles'
import { ITaskTemplatesTab, ITaskTemplateState } from 'types/task-templates.interface'
import { CancelBtn } from 'components/Button/CancelBtn'
import { CheckableList } from 'components/CheckableList/CheckableList'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { ISelectValue } from 'constants/globalTypes'
import { Input } from 'components/Input/Input'
import { CheckableListParser } from 'types/checkableList.interface'
import { parseUnits } from 'features/units/unitsMappers'

export const TaskComponentsTab = ({ state, setState, handleSubmit }: ITaskTemplatesTab) => {

  const parseWorkerComponents: CheckableListParser = (data: any) =>
    data.data.map((item: { id: number; name: string }) => ({
      label: item.name,
      value: item.id,
    }))

  const handleWorkerComponentsChange = (selected: ISelectValue[]) => {
    setState((prev: ITaskTemplateState) => ({
      ...prev,
      workerComponents: selected.map((item) => ({
        id: Number(item.value),
        name: item.label,
      })),
    }))
  }

  const parseTools = (data: any) => {
    return data
      ? [
        ...data.map((item: any) => ({ label: item.name, value: item.id })),
        { label: 'All', value: data.length },
      ]
      : []
  }

  const handleSelect = (value: ISelectValue) => {
    setState((prev: ITaskTemplateState) => {
      const copy = structuredClone(prev)
      if (value.label !== 'CLEAR') {
        copy.toolTypeComponents.push({ component: value, name: '', unit: null })
      } else {
        copy.toolTypeComponents = []
      }
      return copy
    })
  }

  const handleSelectRemove = (item: ISelectValue) => {
    setState((prev: ITaskTemplateState) => {
      const copy = { ...prev }
      copy.toolTypeComponents = copy.toolTypeComponents.filter((i) => i.component.value !== item.value)
      return copy
    })
  }

  const handleComponentName = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target
    setState((prev: ITaskTemplateState) => {
      const copy = { ...prev }
      copy.toolTypeComponents = copy.toolTypeComponents.map(c => c.component.label == name ? { ...c, name: value } : c)
      return copy
    })
  }

  const getComponentName = (name: string) => state.toolTypeComponents.find(c => c.component.label == name).name || ''

  const handleUnitSelect = (value: ISelectValue) => {
    setState((prev: ITaskTemplateState) => {
      const copy = { ...prev }
      copy.toolTypeComponents = copy.toolTypeComponents.map(c => c.component.label == 'Item' ? { ...c, unit: value } : c)
      return copy
    })
  }

  const getSelectedUnit = () => state.toolTypeComponents.find(c => c.component.label == 'Item').unit?.label || null

  return (
    <Animation>
      <Flex between minHeight='600px' gap='2rem'>
        <Flex column width='100%' gap='1rem' >
          <HonestSelectAsyncInput
            name='toolComponents'
            link='tool-type-components'
            onChange={handleSelect}
            defaultValue={state.toolTypeComponents.map(c => ({ label: c.component.label, value: c.component.value }))}
            labelText='Tool components'
            parserFunction={parseTools}
            handleRemove={handleSelectRemove}
            // invalid={state.toolTypeComponents.length < 1}
            multi
          />
          {state.toolTypeComponents.some(c => c.component.value == 1) && <Flex width='100%' gap='1rem' >
            <Input labelText='Machinery Name' placeholder='Enter name' name='Machinery' value={getComponentName('Machinery')} onChange={handleComponentName} />
          </Flex>}
          {state.toolTypeComponents.some(c => c.component.value == 2) && <Flex width='100%' column gap='1rem' >
            <Input labelText='Item Name' placeholder='Enter name' name='Item' value={getComponentName('Item')} onChange={handleComponentName} />
            <HonestSelectAsyncInput
              name='units'
              link='units'
              onChange={handleUnitSelect}
              defaultValue={getSelectedUnit()}
              labelText='Item Unit'
              parserFunction={parseUnits}
            />
          </Flex>}
        </Flex>

        <Flex minWidth='70%' width='100%'>
          <CheckableList
            link='worker-component-fields'
            parserFunction={parseWorkerComponents}
            selected={state.workerComponents.map((wc) => ({
              label: wc.name,
              value: wc.id,
            }))}
            onChange={handleWorkerComponentsChange}
            header='Worker Components'
            searchPlaceholder='Search components'
            selectedLabelText='Selected Worker Components'
            selectedPlaceholder='Nothing selected'
            listMaxHeight='16rem'
          />
        </Flex>
      </Flex>
      <PageFooter>
        <Flex gap='1rem'>
          <CancelBtn />
          <Button orange onClick={handleSubmit}>
            Save
          </Button>
        </Flex>
      </PageFooter>
    </Animation>
  )
}
